import { GenericComboDTO } from "medere-ui-framework"
import { Dispatch, SetStateAction } from "react"
import { AccountingAccount, AdministrativeFormStateTypeI18n, AdministrativeFormStateTypeI18nDTO } from "./interface"

export const MAX_DECIMAL = 2


export interface TotalAmounts {
    netTaxed: Big
    noTaxed: Big
    exempt: Big
    iva: Big
    percIva: Big
    iibb: Big
    others: Big
    total: Big
}

export interface TaxItemVaucher {
    accounting: number | null
    exempttype: boolean
    externalid: number
    forpaymentsfromothers: boolean
    forpaymentstoothers: boolean
    forpurchaseinvoices: boolean
    forsalesinvoices: boolean
    iibb: boolean
    taxaccount: number
    taxaccountdesc: string
    taxaccountidentifier: string
    taxname: string
    taxtype: number
    taxvalue: number
    vatperception: boolean
    vattax: boolean
    exemptvattax?:boolean
    vatnottaxed?:boolean
}

export interface ItemVaucher {
    id: string
    description: string
    account: AccountingAccount | null
    amount: Big
    tax: TaxItemVaucher | null
    taxAmount: Big
    total: Big
}

export interface TaxType {
    taxType: number
    taxName: string
    taxValue: number
    taxAccount: number
    editable: boolean
    visible: boolean
    taxAccountDesc: string
    taxAccountIdentifier: string
    exemptVatTax: boolean
    vatNotTaxed: boolean
}

export interface TaxTypeDTO {
    taxtype: number
    taxname: string
    taxvalue: number
    taxaccount: number
}

export enum ETaxes {
    IVA_0 = 1,
    IVA_10_5 = 2,
    IVA_21 = 3,
    IVA_27 = 4,
    IVA_5 = 5,
    IVA_2_5 = 6,
    INGRESOS_BRUTOS = 7,
    EXENTO = 8,
    PERCEPCIÓN_IVA = 9,
    OTROS_IMPUESTOS = 10,
}

export const otherTaxesToTotalAmountKeys: { [key in ETaxes]?: keyof TotalAmounts } | any = {
    [ETaxes.INGRESOS_BRUTOS]: 'iibb',
    [ETaxes.OTROS_IMPUESTOS]: 'others',
    [ETaxes.PERCEPCIÓN_IVA]: 'percIva',
};

export const otherTaxes = [ETaxes.INGRESOS_BRUTOS, ETaxes.OTROS_IMPUESTOS, ETaxes.PERCEPCIÓN_IVA]

export interface OrderItemTaxesProps {
    totalAmounts: TotalAmounts|any
    setTotalAmounts: Dispatch<SetStateAction<TotalAmounts>>
    items: ItemVaucher[]
}

export interface OrderItemTaxesRef {
    visibleTaxes: TaxType[],
    setTaxes: (newList: TaxType[]) => void,
    taxesWithTaxValues: TaxType[],
    taxes: TaxType[],
    taxesDTO: TaxTypeDTO[],
    getNetAmountNotTaxedItems: () => ItemVaucher[],
}

export interface OrderInfo {
    supplier: any
    pos: number | null
    voucherNumber: number | null
    reicipt: AdministrativeFormStateTypeI18nDTO | null
    orderDate: Date | null
    accountDate?: Date | null
    expirationDate?: Date | null
    payWithCreditCard: boolean
    operationWithSGR: boolean
    description: string
}

export interface EditOrder extends OrderInfo, TotalAmounts {
    items: ItemVaucher[]
    taxes: TaxType[]
}